import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useReveal } from '../hooks/useReveal';
import ParallaxHero from '../components/ParallaxHero';
import { useToast } from '../context/ToastContext';
import SocialIcon from '../components/SocialIcon';
import { CONTACT_INFO, SOCIAL_LINKS, FAQS } from '../data';

export default function Contact() {
  useReveal();
  const showToast = useToast();
  const [form,setForm]=useState({name:'',email:'',phone:'',service:'',budget:'',message:''});
  const [sending,setSending]=useState(false);
  const [sent,setSent]=useState(false);
  const [openFaq,setOpenFaq]=useState(null);
  const TO='ravi12463@gmail.com';

  async function handleSubmit(e) {
    e.preventDefault();
    if(!form.name) return showToast('⚠️ Please enter your full name.',true);
    if(!form.email||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return showToast('⚠️ Please enter a valid email address.',true);
    if(!form.service) return showToast('⚠️ Please select a service.',true);
    if(!form.message) return showToast('⚠️ Please describe your project.',true);
    setSending(true);
    try {
      if(typeof window.emailjs!=='undefined'&&window.emailjs._userID!=='YOUR_EMAILJS_PUBLIC_KEY') {
        await window.emailjs.send('YOUR_SERVICE_ID','YOUR_TEMPLATE_ID',{from_name:form.name,from_email:form.email,phone:form.phone||'N/A',service:form.service,budget:form.budget||'N/A',message:form.message,to_email:TO,reply_to:form.email});
      } else {
        const sub=encodeURIComponent(`ITClave Enquiry: ${form.service} — ${form.name}`);
        const body=encodeURIComponent(`New lead from ITClave website\n\nName: ${form.name}\nEmail: ${form.email}\nPhone: ${form.phone||'N/A'}\nService: ${form.service}\nBudget: ${form.budget||'N/A'}\n\nMessage:\n${form.message}`);
        window.open(`mailto:${TO}?subject=${sub}&body=${body}`);
      }
      setSent(true); showToast('✅ Message sent! We will reply within 24 hours.');
    } catch(err) {
      const sub=encodeURIComponent(`ITClave Enquiry: ${form.service} — ${form.name}`);
      const body=encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\nService: ${form.service}\n\nMessage:\n${form.message}`);
      window.open(`mailto:${TO}?subject=${sub}&body=${body}`);
      showToast('📧 Opening your email client...');
    } finally { setSending(false); }
  }

  return (
    <>
      <Helmet>
        <title>Contact ITClave | Get Free Quote — India's Best IT Company</title>
        <meta name="description" content="Contact ITClave for web development, digital marketing, mobile apps, or custom software. Free consultation. Reply within 24 hours. Serving businesses across India."/>
        <meta name="keywords" content="contact IT company India, hire web developer India, digital marketing agency contact India, get free quote software development India"/>
      </Helmet>

      <ParallaxHero
        page="contact"
        eyebrow="Get In Touch"
        title="Contact Us"
        subtitle="Let's talk about your project. Free consultation within 24 hours — no commitment required."
        cta={false}
      />

      <section style={{background:'var(--bg)',padding:'80px 0'}}>
        <div className="container">
          <div style={{display:'grid',gridTemplateColumns:'1fr 1.5fr',gap:60,alignItems:'start'}} className="ct-layout">
            <div className="rl">
              <div className="eyebrow">Contact Us</div>
              <h2 style={{fontFamily:"'Outfit',sans-serif",fontSize:'clamp(1.7rem,3vw,2.2rem)',fontWeight:900,color:'var(--text)',letterSpacing:'-.04em',marginBottom:12}}>Talk to Our <span className="gt">Expert Team</span></h2>
              <p style={{color:'var(--text2)',fontSize:'.93rem',lineHeight:1.8,marginBottom:26}}>Tell us about your project. We'll connect you with the right expert and send a custom proposal within 48 hours. We serve businesses across India.</p>
              <div style={{display:'flex',flexDirection:'column',gap:11,marginBottom:22}}>
                {[
                  {ic:'📍',l:'Address',v:CONTACT_INFO.address,href:null},
                  {ic:'📞',l:'Phone',  v:CONTACT_INFO.phone,  href:`tel:+917808707393`},
                  {ic:'✉️',l:'Email',  v:CONTACT_INFO.email,  href:`mailto:${CONTACT_INFO.email}`},
                  {ic:'⏰',l:'Hours',  v:CONTACT_INFO.hours,  href:null},
                ].map(c=>{
                  const Tag=c.href?'a':'div';
                  return(
                    <Tag key={c.l} href={c.href} style={{display:'flex',alignItems:'center',gap:13,background:'#fff',border:'1.5px solid var(--border2)',borderRadius:14,padding:'13px 16px',transition:'all .3s',textDecoration:'none'}}
                      onMouseOver={e=>{e.currentTarget.style.borderColor='var(--purple)';e.currentTarget.style.background='var(--purple-lt)';e.currentTarget.style.transform='translateX(4px)';}}
                      onMouseOut={e=>{e.currentTarget.style.borderColor='var(--border2)';e.currentTarget.style.background='#fff';e.currentTarget.style.transform='';}}>
                      <div style={{width:38,height:38,background:'linear-gradient(135deg,#E8315B,#7B52AB,#4BB8E8)',borderRadius:11,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'.88rem',flexShrink:0}}>{c.ic}</div>
                      <div>
                        <div style={{fontSize:'.68rem',color:'var(--text3)',fontWeight:700,letterSpacing:'.07em',textTransform:'uppercase'}}>{c.l}</div>
                        <div style={{fontSize:'.88rem',fontWeight:700,color:'var(--text)',marginTop:1}}>{c.v}</div>
                      </div>
                    </Tag>
                  );
                })}
              </div>
              <div style={{borderRadius:16,overflow:'hidden',border:'1px solid var(--border)',marginBottom:20}}>
                <iframe src={CONTACT_INFO.map_src} allowFullScreen loading="lazy" title="ITClave Office" style={{width:'100%',height:185,border:'none',display:'block'}}/>
              </div>
              <div style={{fontSize:'.72rem',fontWeight:800,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:12}}>Follow Us</div>
              <div style={{display:'flex',gap:9,flexWrap:'wrap'}}>
                {SOCIAL_LINKS.map(s=><SocialIcon key={s.icon} icon={s.icon} url={s.url} name={s.name} size={36} radius={10}/>)}
              </div>
            </div>

            <div className="rr">
              <div style={{background:'#fff',border:'1.5px solid var(--border2)',borderRadius:24,padding:36,boxShadow:'var(--sh)'}}>
                {!sent?(
                  <>
                    <div style={{fontFamily:"'Outfit',sans-serif",fontSize:'1.2rem',fontWeight:900,color:'var(--text)',letterSpacing:'-.03em',marginBottom:22}}>Send Us a Message 📩</div>
                    <form onSubmit={handleSubmit} noValidate>
                      <div className="form-row">
                        <div className="fg"><label>Full Name *</label><input type="text" placeholder="Your full name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required/></div>
                        <div className="fg"><label>Email *</label><input type="email" placeholder="your@email.com" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} required/></div>
                      </div>
                      <div className="form-row">
                        <div className="fg"><label>Phone</label><input type="tel" placeholder="+91 98765 43210" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})}/></div>
                        <div className="fg"><label>Service *</label>
                          <select value={form.service} onChange={e=>setForm({...form,service:e.target.value})} required>
                            <option value="">Select service</option>
                            {['Web Development','Digital Marketing','Mobile App Development','SEO Services','UI/UX Design','Custom Software / ERP','Cloud & DevOps','E-Commerce Solutions','Other'].map(s=><option key={s}>{s}</option>)}
                          </select>
                        </div>
                      </div>
                      <div className="fg"><label>Budget Range</label>
                        <select value={form.budget} onChange={e=>setForm({...form,budget:e.target.value})}>
                          <option value="">Select budget</option>
                          {['Below ₹15,000','₹15,000 – ₹50,000','₹50,000 – ₹1,50,000','₹1,50,000 – ₹5,00,000','Above ₹5,00,000'].map(b=><option key={b}>{b}</option>)}
                        </select>
                      </div>
                      <div className="fg"><label>Project Details *</label><textarea placeholder="Tell us about your project, goals, timeline, and any specific requirements..." value={form.message} onChange={e=>setForm({...form,message:e.target.value})} required/></div>
                      <button type="submit" className="form-sub" disabled={sending}>{sending?'⏳ Sending...':'Send Message →'}</button>
                      <div className="form-note">🔒 Your information is 100% secure and never shared with third parties.</div>
                    </form>
                  </>
                ):(
                  <div style={{textAlign:'center',padding:'32px 16px'}}>
                    <div style={{fontSize:'3.5rem',marginBottom:14}}>✅</div>
                    <h3 style={{fontFamily:"'Outfit',sans-serif",fontSize:'1.3rem',fontWeight:900,color:'var(--text)',marginBottom:9}}>Message Sent Successfully!</h3>
                    <p style={{color:'var(--text2)',fontSize:'.9rem',lineHeight:1.72,marginBottom:22}}>Our team will reply within <strong>24 hours</strong>. Meanwhile, connect with us on social media.</p>
                    <button className="btn-main" style={{border:'none'}} onClick={()=>{setSent(false);setForm({name:'',email:'',phone:'',service:'',budget:'',message:''});}}>Send Another Message</button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section style={{background:'var(--bg3)',padding:'80px 0'}}>
        <div className="container">
          <div className="sec-hdr-center"><div className="eyebrow" style={{justifyContent:'center'}}>Got Questions?</div><h2 className="sec-title">Frequently Asked <span className="gt">Questions</span></h2></div>
          <div style={{display:'grid',gridTemplateColumns:'1.2fr 1fr',gap:52,alignItems:'start',marginTop:48}} className="faq-layout">
            <div style={{display:'flex',flexDirection:'column',gap:12}}>
              {FAQS.map((f,i)=>(
                <div key={i} style={{border:'1.5px solid',borderRadius:18,overflow:'hidden',transition:'all .3s',borderColor:openFaq===i?'rgba(123,82,171,.25)':'var(--border2)',boxShadow:openFaq===i?'var(--sh-lg)':'none',background:'#fff'}}>
                  <div onClick={()=>setOpenFaq(openFaq===i?null:i)} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'17px 20px',cursor:'pointer',background:openFaq===i?'var(--purple-lt)':'#fff',transition:'background .3s',gap:12}}>
                    <span style={{fontWeight:700,fontSize:'.9rem',color:'var(--text)',lineHeight:1.4}}>{f.q}</span>
                    <span style={{width:28,height:28,borderRadius:'50%',background:openFaq===i?'var(--grad)':'var(--grad-soft)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'.9rem',fontWeight:900,color:openFaq===i?'#fff':'var(--purple)',flexShrink:0,transform:openFaq===i?'rotate(45deg)':'none',transition:'all .3s'}}>+</span>
                  </div>
                  {openFaq===i&&<div style={{padding:'0 20px 17px',background:'#fff'}}><p style={{fontSize:'.87rem',color:'var(--text2)',lineHeight:1.8}}>{f.a}</p></div>}
                </div>
              ))}
            </div>
            <div style={{background:'var(--grad)',borderRadius:24,padding:36,textAlign:'center',position:'sticky',top:100}}>
              <div style={{fontSize:'2.4rem',marginBottom:12}}>💬</div>
              <h3 style={{fontFamily:"'Outfit',sans-serif",fontSize:'1.25rem',fontWeight:900,color:'#fff',marginBottom:10}}>Still have questions?</h3>
              <p style={{color:'rgba(255,255,255,.78)',fontSize:'.88rem',lineHeight:1.72,marginBottom:20}}>Chat with us on WhatsApp. Available Mon–Sat 9AM–6PM IST.</p>
              <a href={CONTACT_INFO.whatsapp} target="_blank" rel="noopener noreferrer" className="btn-white" style={{justifyContent:'center',width:'100%',display:'flex',marginBottom:16}}>💬 Chat on WhatsApp</a>
              <div style={{marginTop:20,paddingTop:18,borderTop:'1px solid rgba(255,255,255,.18)'}}>
                <div style={{fontSize:'.77rem',color:'rgba(255,255,255,.68)',fontWeight:700,textTransform:'uppercase',letterSpacing:'.08em',marginBottom:6}}>Average response time</div>
                <div style={{fontFamily:"'Outfit',sans-serif",fontSize:'1.35rem',fontWeight:900,color:'#fff'}}>Under 2 hours ⚡</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`@media(max-width:1024px){.ct-layout,.faq-layout{grid-template-columns:1fr!important}}`}</style>
    </>
  );
}
